if (!customElements.get('td-accordion')) {
  class TdAccordion extends HTMLElement {
  
  constructor() {
    super();
    this.ACCORDION_TRIGGER = this.querySelector('[data-accordion-trigger]');
    this.ACCORDION_CONTENT = this.querySelector('[data-accordion-content]');
    this.ACTIVE_CLASS = 'td-active';
    this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
    this.OPEN_ONE_AT_TIME = this.hasAttribute('one-at-time');
    
    this.boundToggleAccordion = this.toggleAccordion.bind(this);
    this.boundSetInitialAccordionHeight = this.setInitialAccordionHeight.bind(this);
  }
  
    connectedCallback() {
      if (!this.ACCORDION_CONTENT && !this.ACCORDION_TRIGGER) {
        return;
      }
      this.setInitialAccordionHeight();
      this.attachListeners();
    }

    setInitialAccordionHeight() {
      this.isExpanded = this.classList.contains(this.ACTIVE_CLASS);
      if (this.isExpanded) {
        this.ACCORDION_CONTENT.style.maxHeight = this.ACCORDION_CONTENT.scrollHeight + 'px';
      } else {
        this.ACCORDION_CONTENT.style.maxHeight = '0px';
      }
    }
  
  attachListeners() {
    this.ACCORDION_TRIGGER.addEventListener('click', this.boundToggleAccordion);
    window.addEventListener('resize', this.boundSetInitialAccordionHeight);
  }
  
  disconnectedCallback() {
    if (this.ACCORDION_TRIGGER) {
      this.ACCORDION_TRIGGER.removeEventListener('click', this.boundToggleAccordion);
    }
    window.removeEventListener('resize', this.boundSetInitialAccordionHeight);
  }

    open(dropdown) {
      dropdown.ACCORDION_CONTENT.style.maxHeight = dropdown.ACCORDION_CONTENT.scrollHeight + 'px';
      dropdown.classList.add(this.ACTIVE_CLASS);
    }

    close(dropdown) {
      dropdown.ACCORDION_CONTENT.style.maxHeight = '0px';
      dropdown.classList.remove(this.ACTIVE_CLASS);
    }

    toggleAccordion() {
      if (this.OPEN_ONE_AT_TIME) {
        const accordionWrapper = this.closest('[data-accordion-wrapper]');
        if (!accordionWrapper) {
          console.error('Accordion wrapper not found');
          return;
        }
        const allOpenedAccordions = accordionWrapper.querySelectorAll(`td-accordion.${this.ACTIVE_CLASS}`);
        allOpenedAccordions.forEach(accordion => {
          if (accordion !== this) {
            this.close(accordion);
          }
        });
      }

      this.classList.contains(this.ACTIVE_CLASS)
        ? this.close(this)
        : this.open(this);
    }
    
  }
  customElements.define('td-accordion', TdAccordion);
}
